import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import { Options, Select } from '../../components/Select';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import api from '../../services/api';
import './style.css';
import { useParams } from 'react-router-dom';


export function FuncionariosCadastrar() {
  const { idEmpresa } = useParams(); 

  const [isLoading, setIsLoading] = useState(true);
  {/* Informações Pessoais */ }
  const [name, setName] = useState('');
  const [cpf, setCpf] = useState('');
  const [rg, setRg] = useState('');
  const [data_nascimento, setDataNascimento] = useState('');
  const [sexo, setSexo] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [celular, setCelular] = useState('');
  {/* Informações Trabalhistas */ }
  const [frenteTrabalho, setFrenteTrabalho] = useState('');
  const [funcao, setFuncao] = useState('');
  const [ghe, setGhe] = useState('');
  const [pis, setPis] = useState('');
  const [matricula, setMatricula] = useState('');
  const [ct_num, setct_num] = useState('');
  const [ct_serie, setct_serie] = useState('');
  const [ct_uf, setct_uf] = useState('');

  {/* Informações Residenciais */ }
  const [cep, setCep] = useState('');
  const [endereco, setEndereco] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [complemento, setComplemento] = useState('');
  const [estado, setEstado] = useState('');
  const [cidade, setCidade] = useState('');
  const [obs, setobs] = useState('');

  const [isInputTyped, setIsInputTyped] = useState(false);

  const [frenteTrabalhoSelecionada, setFrenteTrabalhoSelecionada]: any = useState(null);
  const [gheSelecionado, setGheSelecionado]: any = useState(null);
  const [funcaoSelecionada, setFuncaoSelecionada]: any = useState(null);


  const [opcoesFrenteTrabalho, setOpcoesFrenteTrabalho] = useState([]);
  const [opcoesFuncao, setOpcoesFuncao] = useState([]);
  const [opcoesGhe, setOpcoesGhe] = useState([]);

  // Criar referências
  const refNome: any = useRef(null);
  const refCpf: any = useRef(null);
  const refSexo: any = useRef(null);
  const refIdFdt: any = useRef(null);
  const refIdFuncao: any = useRef(null);

  const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

  const [isNomeInvalido, setIsNomeInvalido] = useState(false);
  const [isCpfInvalido, setIsCpfInvalido] = useState(false);
  const [isSexoInvalido, setIsSexoInvalido] = useState(false);
  const [isFdtInvalido, setIsFdtInvalido] = useState(false);
  const [isFuncaoInvalida, setIsFuncaoInvalida] = useState(false);

  useEffect(() => {
    const buscarFdtsEmpresa = async () => {
      try {
        const response = await api.get(`funcionarios/listar-fdts-empresa/${idEmpresa}`);
        setOpcoesFrenteTrabalho(response.data);
      } catch (error) {
        console.error('Erro ao buscar todas as frentes de trabalho', error);
      }
    };

    buscarFdtsEmpresa();
  }, []);

  useEffect(() => {
    const buscarGhesEmpresa = async () => {
      try {
        const response = await api.get(`funcionarios/listar-ghes-empresa/${idEmpresa}`);
        setOpcoesGhe(response.data);
      } catch (error) {
        console.error('Erro ao buscar todos os GHEs', error);
      }
    };

    buscarGhesEmpresa();
  }, []);

  const buscarFuncao = async (inputValue: any) => {
    if (!inputValue || inputValue.trim() === "") {
      setOpcoesFuncao([]);
      return;
    }

    try {
      const response = await api.get(`funcionarios/buscar-funcao/${inputValue}`);
      setOpcoesFuncao(response.data);
    } catch (error) {
      console.error('Erro ao buscar funções', error);
    }
  };


  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  });

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    setAlert({ message: 'Funcionário cadastrado', variant: 'success', show: true });

    const nome = name.toUpperCase()

    const payload = {

      nome,
      cpf,
      rg,
      data_nascimento,
      sexo,
      email,
      telefone,
      celular,
      id_empresa: idEmpresa,
      id_fdt: frenteTrabalhoSelecionada ? frenteTrabalhoSelecionada.id : null,
      id_ghe: gheSelecionado ? gheSelecionado.id : null,
      id_funcao: funcaoSelecionada ? funcaoSelecionada.id : null,
      pis,
      matricula,
      ct_num,
      ct_serie,
      ct_uf,
      cep,
      endereco,
      numero,
      bairro,
      complemento,
      estado,
      cidade,
      obs,
      status: 1

    };
    let isValid = true;

    if (!nome) {
      setAlert({ message: 'Por favor, preencha o campo nome', variant: 'danger', show: true });
      setIsNomeInvalido(true);
      refNome.current.focus();
      isValid = false;
    } else {
      setIsNomeInvalido(false);
    }

    if (!cpf) {
      setAlert({ message: 'Por favor, preencha o campo CPF.', variant: 'danger', show: true });
      setIsCpfInvalido(true);
      isValid = false;
    } else {
      setIsCpfInvalido(false);
    }

    if (!sexo) {
      setAlert({ message: 'Por favor, selecione o campo sexo.', variant: 'danger', show: true });
      setIsSexoInvalido(true);
      isValid = false;
    } else {
      setIsSexoInvalido(false);
    }

    if (!frenteTrabalhoSelecionada) {
      setAlert({ message: 'Por favor, selecione a frente de trabalho.', variant: 'danger', show: true });
      setIsFdtInvalido(true);
      isValid = false;
    } else {
      setIsFdtInvalido(false);
    }

    if (!funcaoSelecionada) {
      setAlert({ message: 'Por favor, selecione a função do funcionário.', variant: 'danger', show: true });
      setIsFuncaoInvalida(true);
      isValid = false;
    } else {
      setIsFuncaoInvalida(false);
    }

    try {
      const response = await api.post('/funcionarios/cadastro', payload);
      setAlert({ message: 'Funcionário cadastrado', variant: 'success', show: true });
      refNome.current.focus();
      setName('');
      setCpf('');
      setRg('');
      setDataNascimento('');
      setSexo('');
      setEmail('');
      setTelefone('');
      setCelular('');
      setFrenteTrabalhoSelecionada(null);
      setGheSelecionado(null);
      setFuncaoSelecionada(null);
      setPis('');
      setMatricula('');
      setct_num('');
      setct_serie('');
      setct_uf('');
      setCep('');
      setEndereco('');
      setNumero('');
      setBairro('');
      setComplemento('');
      setEstado('');
      setCidade('');
      setobs('');
    
      // Aqui você pode tratar a resposta, como redirecionar o usuário ou mostrar uma mensagem de sucesso
    } catch (error) {
      console.error('Erro ao enviar dados do formulário:', error);
      // Aqui você pode tratar o erro, como mostrar uma mensagem para o usuário
    }
  };

  const handleSelectSexo = (id: any, e: any) => {
    setSexo(id);
  };

  const handleCepChange = async (e: any) => {
    const cep = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
    setCep(cep);

    if (cep.length === 8) {
      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        const { logradouro, bairro, localidade, uf } = response.data;

        setEndereco(logradouro);
        setBairro(bairro);
        setEstado(uf);
        setCidade(localidade);
      } catch (error) {
        console.error('Erro ao buscar o CEP', error);
        // Tratar possíveis erros, como CEP não encontrado
      }
    }
  };

  return (
    <div>
      <Load isLoading={isLoading} />
      <Sidebar />
      <Header route='../../' />
      <Main>
        <Form onSubmit={handleSubmit}>
          <h3>Informações Pessoais</h3>
          <Row>
            <Col xs={12} md={6} xl={6}>
              <FormGroup>
                <Label title='Nome *' htmlFor="nome" />
                <input
                  type="text"
                  id="nome"
                  placeholder="Digite o Nome"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value) {
                      setIsNomeInvalido(false); // Restaura o estado se o usuário começar a digitar
                    }
                  }}
                  className={isNomeInvalido ? 'invalid' : ''}
                  style={{ width: '100%' }}
                  ref={refNome} // Adicione esta linha
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={3} xl={3}>
              <FormGroup>
                <Label title='CPF *' htmlFor="cpf" />
                <InputMask
                  mask="999.999.999-99"
                  id='cpf'
                  value={cpf}
                  onChange={(e: any) => setCpf(e.target.value)}
                  className={isCpfInvalido ? 'invalid-field' : ''}
                  placeholder="Digite o CPF"
                  style={{ width: '100%' }}
                  ref={refCpf} // Adicione esta linha
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={3} xl={3}>
              <FormGroup>
                <Label title='RG' htmlFor="rg" />
                <InputMask
                  mask="99.999.999-9"
                  value={rg}
                  onChange={(e: any) => setRg(e.target.value)}
                  placeholder="Digite o RG"
                  className="form-control"
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className='my-4'>
            {/* Data de Nascimento */}
            <Col xs={12} md={3} xl={3}>
              <FormGroup>
                <Label title='Data de Nascimento' htmlFor="dataNascimento" />
                <input
                  type="date"
                  id="dataNascimento"
                  value={data_nascimento}
                  onChange={(e) => setDataNascimento(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

            {/* Sexo */}
            <Col xs={12} md={3} xl={3}>
              <FormGroup>
                <Label title='Sexo *' htmlFor="sexo" />
                <Select width="600px" id='empresas' onSelect={handleSelectSexo}
                  className={isSexoInvalido ? 'invalid-field' : ''}

                >
                  <Options key='M' value='M' name='Masculino' />
                  <Options key='F' value='F' name='Feminino' />
                </Select>
              </FormGroup>
            </Col>

          </Row>
          <Row>
            {/* Email */}
            <Col xs={12} md={6} xl={6}>
              <FormGroup>
                <Label title='Email' htmlFor="email" />
                <input
                  type="text"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ width: '100%' }}
                  placeholder='example@example.com'
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={3} xl={3}>
              <FormGroup>
                <Label title='Telefone' htmlFor="telefone" />
                <InputMask
                  mask="(99) 9999-9999"
                  value={telefone}
                  onChange={(e: any) => setTelefone(e.target.value)}
                  placeholder="(__) ____-____"
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={3} xl={3}>
              <FormGroup>
                <Label title='Celular' htmlFor="celular" />
                <InputMask
                  mask="(99) 99999-9999"
                  value={celular}
                  onChange={(e: any) => setCelular(e.target.value)}
                  placeholder="(__) _____-____"
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

          </Row>

          <h3 className='mt-4'>Informações Trabalhistas</h3>
          <Row>
            <Col xs={12} md={4}>
              <FormGroup>
                <Label title='Frente de Trabalho *' htmlFor="frenteTrabalho" />
                <Autocomplete
                  value={frenteTrabalhoSelecionada}
                  onChange={(event, newValue) => {
                    setFrenteTrabalhoSelecionada(newValue);
                    setIsFdtInvalido(false);
                  }}
                  className={isFdtInvalido ? 'invalid-field' : ''}
                  options={opcoesFrenteTrabalho}
                  getOptionLabel={(option) => option.nome || ""}
                  renderInput={(params) => <TextField {...params} label="" />}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={4}>
              <FormGroup>

                <Label title='GHE (Setor)' htmlFor="ghe" />
                <Autocomplete
                  value={gheSelecionado}
                  onChange={(event, newValue) => {
                    setGheSelecionado(newValue);
                  }}
                  options={opcoesGhe}
                  getOptionLabel={(option: any) => option.nome || ""}
                  style={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="" />}
                />

              </FormGroup>
            </Col>

            <Col xs={12} md={4}>
              <FormGroup>
                <Label title='Função *' htmlFor="funcao" />
                <Autocomplete
                  value={funcaoSelecionada}
                  onChange={(event, newValue) => {
                    setFuncaoSelecionada(newValue);
                  }}
                  onInputChange={(event, newInputValue) => {
                    buscarFuncao(newInputValue);
                  }}
                  noOptionsText="Digite e selecione"
                  options={opcoesFuncao}
                  getOptionLabel={(option: any) => option.nome || ""}
                  style={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="" />}

                />
              </FormGroup>
            </Col>
          </Row>

          <Row className='my-4'>
            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='PIS' htmlFor="pis" />
                <input
                  type="text"
                  id="pis"
                  placeholder="Digite o PIS"
                  value={pis}
                  onChange={(e) => setPis(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='Matrícula' htmlFor="matricula" />
                <input
                  type="text"
                  id="matricula"
                  placeholder="Digite a matrícula"
                  value={matricula}
                  onChange={(e) => setMatricula(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={4}>
              <FormGroup>
                <Label title='Carteira de Trabalho (Número)' htmlFor="ct_num" />
                <input
                  type="text"
                  id="ct_num"
                  placeholder="Número da CTPS"
                  value={ct_num}
                  onChange={(e) => setct_num(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={4}>
              <FormGroup>
                <Label title='Carteira de Trabalho (Série)' htmlFor="ct_serie" />
                <input
                  type="text"
                  id="ct_serie"
                  placeholder="Série da CTPS"
                  value={ct_serie}
                  onChange={(e) => setct_serie(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={4}>
              <FormGroup>
                <Label title='Carteira de Trabalho (UF)' htmlFor="ct_uf" />
                <input
                  type="text"
                  id="ct_uf"
                  placeholder="UF da CTPS"
                  value={ct_uf}
                  onChange={(e) => setct_uf(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>
          </Row>

          <h3>Endereço Residencial</h3>
          <Row>
            <Col xs={12} md={3}>
              <FormGroup>
                <Label title='CEP' htmlFor="cep" />
                <InputMask
                  mask="99999-999"
                  type="text"
                  id="cep"
                  placeholder="Digite o CEP"
                  value={cep}
                  onChange={handleCepChange}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='Endereço' htmlFor="endereco" />
                <input
                  type="text"
                  id="endereco"
                  placeholder="Endereço"
                  value={endereco}
                  onChange={(e) => setEndereco(e.target.value)}
                  style={{ width: '100%' }}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={3}>
              <FormGroup>
                <Label title='Número' htmlFor="numero" />
                <input
                  type="text"
                  id="numero"
                  placeholder="Número"
                  value={numero}
                  onChange={(e) => setNumero(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className='my-4'>
            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='Bairro' htmlFor="bairro" />
                <input
                  type="text"
                  id="bairro"
                  placeholder="Bairro"
                  value={bairro}
                  onChange={(e) => setBairro(e.target.value)}
                  style={{ width: '100%' }}
                  disabled
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='Complemento' htmlFor="complemento" />
                <input
                  type="text"
                  id="complemento"
                  placeholder="Complemento"
                  value={complemento}
                  onChange={(e) => setComplemento(e.target.value)}
                  style={{ width: '100%' }}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='Cidade' htmlFor="cidade" />
                <input
                  type="text"
                  id="cidade"
                  placeholder="Cidade"
                  value={cidade}
                  onChange={(e) => setCidade(e.target.value)}
                  style={{ width: '100%' }}
                  disabled
                />
              </FormGroup>
            </Col>

            <Col xs={12} md={6}>
              <FormGroup>
                <Label title='Estado' htmlFor="estado" />
                <input
                  type="text"
                  id="estado"
                  placeholder="Estado"
                  value={estado}
                  onChange={(e) => setEstado(e.target.value)}
                  style={{ width: '100%' }}
                  disabled
                />
              </FormGroup>
            </Col>

          </Row>

          <Row className='mt-4'>
            <Col xs={12}>
              <FormGroup>
                <Label title='Observações' htmlFor="obs" />
                <textarea
                  id="obs"
                  placeholder="Digite observações"
                  value={obs}
                  onChange={(e) => setobs(e.target.value)}
                  style={{ width: '100%', minHeight: '100px' }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Button className="btn-main mt-4" type="submit">Inserir Usuário</Button>
        </Form>
      </Main>
      <AlertMessage
        show={alert.show}
        message={alert.message}
        variant={alert.variant}
        onClose={() => setAlert({ ...alert, show: false })}
      />
    </div>
  );
}
